<template>
  <div class="exam-card">
    <div class="tags">
      <div class="tag">
        <span>{{computeTime()}}</span>
      </div>
    </div>
    <div class="content-wrap">
      <div class="left">
        <img :src="content.picture_url">
      </div>
      <div class="right">
        <p class="title">{{content.name}}</p>
        <div class="count">
          <span>共计{{content.item_count || 0}}题</span>
        </div>
        <div class="price">
          <span class="old">¥{{content.reference_price}}</span>
          <span class="new">¥{{content.price}}</span>
        </div>
      </div>
    </div>
    <div class="item-footer">
      <span class="subject-name" :title="(content.subjects && content.subjects.length) ? content.subjects[0].name : ''">{{(content.subjects && content.subjects.length) ? content.subjects[0].name : ''}}</span>
      <span class="member-count">{{content.user_count}}开通</span>
    </div>
    <div class="menu">
      <div class="menu-item" @click="handleToRestore">
        <i class="el-icon-refresh-left"></i>
        <span>还原</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToClone">
        <i class="el-icon-document-copy"></i>
        <span>克隆</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
import { examRemove, examRestore, examClone } from '@/api/exam'
import { formatTime } from '@/utils/helper'

export default {
  name: 'exercise-card',
  props: {
    content: {
      type: Object,
      default: () => {return {}}
    }
  },
  data() {
    return {}
  },
  methods: {
    // 倒计时计算
    computeTime() {
      if (!this.content.update_time) { return '' }
      const time = this.$moment(this.content.update_time).add(30, 'days').valueOf()  - Date.now()
      return formatTime(time/1000)
    },
    // 还原
    handleToRestore() {
      // 二次确认
      this.$confirm('确定要还原吗？', '提示', {
        type: 'warning'
      }).then(() => {
        examRestore({id: this.content.id}).then(res => {
          this.$message.success(`还原成功，请在内容管理中查看`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
    // 克隆
    handleToClone() {
      // 二次确认
      this.$confirm('确定要克隆吗？', '提示', {
        type: 'warning'
      }).then(() => {
        examClone({id: this.content.id}).then(res => {
          this.$message.success(`克隆成功，请在内容管理中查看`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
    // 删除
    handleToRemove() {
      // 二次确认
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning'
      }).then(() => {
        examRemove({id: this.content.id}).then(res => {
          this.$message.success(`删除成功`)
          this.$emit('submit')
        })
      }).catch(() => {})
    },
  }
}
</script>

<style lang="less" scoped>
.exam-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #FFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 30px 10px 0px;
  overflow: hidden;

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409EFF;
      }
    }
  }

  .content-wrap {
    display: flex;

    .left {
      margin-right: 10px;
    }
    .right {
      flex: 1;
      overflow: hidden;
    }
    img {
      width: 69px;
      height: 94px;
      object-fit: cover;
    }
    .title {
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .count {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      font-size: 12px;
    }
    .price {
      display: flex;
      flex-direction: column;
      margin-top: 15px;
      font-weight: bold;
      font-size: 16px;

      .old {
        text-decoration: line-through;
        color: #999;
      }
      .new {
        margin-top: 2px;
        color: #f00;
      }
    }
    .title {
      font-size: 16px;
      font-weight: bold;
    }
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666;
    margin-top: 10px;

    .subject-name {
      flex: 1;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .member-count {
      margin-left: 10px;
    }
  }
  a {
    text-decoration: none;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    margin: 10px -10px 0;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
